import AgyleDialog from '../modal/agyleDialog';
import {Stack, Switch} from '@mui/material';
import Typography from '@mui/material/Typography';
import AgyleButton from '../ui/buttons/agyleButton';
import ObservationTable from './observationTable';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import useStickyState from '../../hooks/useStickyState';
import {addObservationsToExaminationInput} from '../../pages/ward/forms/observation/obsUtils';
import Formatter from '../../util/formatter';

const ObservationsComparison = ({patient, open, onClose, chosenObs, setChosenObs, setDataObject}) => {
    const {t} = useTranslation();

    const [oneByOne, setOneByOne] = useStickyState(false, 'agyle_obsSideBySide');
    const [isOneByOne, setIsOneByOne] = useState(false);

    useEffect(() => {
        setIsOneByOne(oneByOne);
    }, []);

    const handleObsModeChange = () => {
        setOneByOne(prev => !prev);
        setIsOneByOne(prev => !prev);
    };

    const addObsAndClose = () => {
        let note = '';

        if (isOneByOne) {
            addObservationsToExaminationInput(chosenObs, setChosenObs, setDataObject, 'examination');
        } else {
            chosenObs.forEach(obsNote => {
                const tempNote = Formatter.formatObservationToText(obsNote);
                note = note !== '' ? note + '\n\n' + tempNote : tempNote;
            });
            setDataObject(prevState => ({
                ...prevState,
                examination: prevState.examination !== '' ? prevState.examination + '\n\n' + note : note,
            }));
        }
        onClose();
    };

    return (
        <AgyleDialog
            title={t('Observations Comparison')}
            open={open}
            onClose={onClose}
            disableSave
            width="xl"
            buttons={[
                <Stack direction="row" spacing={1} alignItems="center" sx={{mr: 3}}>
                    <Typography>
                        {t('Under')}
                    </Typography>

                    <Switch checked={isOneByOne} onChange={handleObsModeChange}/>

                    <Typography>{t('Side by side')}</Typography>
                </Stack>,

                <AgyleButton
                    variant="contained"
                    color="primary"
                    onClick={addObsAndClose}
                >
                    {t('Add and copy to clipboard')}
                </AgyleButton>,
            ]}
        >
            <ObservationTable patient={patient} chooseObs chosenObs={chosenObs} setChosenObs={setChosenObs}/>
        </AgyleDialog>
    );
};

export default ObservationsComparison;